<template>
  <div class="my-rewards-wrapper" v-r-loading="pageLoading">
    <div class="header-box">
      <PageMbHeader
        :title="$t('我的奖励')"
        :transShow="false"
        :transOpen="false"
        @icon-click="iconClick"
      />
    </div>
    <div class="content-box" v-if="!pageLoading">
      <Rewards
        :isOpen="false"
        :rewardedAmount="rewardedAmount"
        :pendingAmount="pendingAmount"
      />
      <EmptyState v-if="!rewardList.length" emptyType="noRewards" />
      <List
        v-else
        :disabled="disabled"
        :load-more-status="loadMoreStatus"
        @more="loadMore"
      >
        <ul class="reward-list-wrapper">
          <li
            class="reward-item"
            v-for="(item, index) in rewardList"
            :key="index"
          >
            <img
              class="friend-logo"
              :src="item.headImg"
              v-http2
              v-img-size="'medium'"
              v-img-error
            />
            <div class="center-box">
              <div class="center-cell">
                <p class="nick-name" v-text="item.nickName"></p>
                <p class="status-desc" v-text="item.info"></p>
              </div>
            </div>
            <div class="right-box">
              <p :class="(rewardStatusMap[item.rewardStatus] ? rewardStatusMap[item.rewardStatus].class : 'pending')">{{ getRewardItemMoney(item) }}</p>
            </div>
          </li>
        </ul>
      </List>
    </div>
  </div>
</template>

<script>
import i18n from '@/i18n/locale'
import api from '@/api'
import List from '@/components/List'
import Rewards from '@/components/InviteFriedns/rewards.vue'
import PageMbHeader from '@/components/PageMbHeader'
import EmptyState from '@/components/EmptyState';
const rewardStatusMap ={
  0: {
    class: 'pending',
    desc: i18n.t('待入账'),
  },
  1: {
    class: 'end',
    desc: '',
  },
  2: {
    class: 'no-suc',
    desc: i18n.t('已过期'),
  }
}
export default {
  name: 'MyRewards',
  components: {
    List,
    Rewards,
    EmptyState,
    PageMbHeader,
  },
  props: {
    activityId: String,
    code: String,
  },
  data() {
    return {
      rewardStatusMap: rewardStatusMap,
      pageLoading: false,
      rewardedAmount: 0,
      pendingAmount: 0,
      rewardList: [],
      disabled: false,
      loadMoreStatus: 'suc', // 加载状态 suc fail nomore loading
      page: 0,
      pageSize: 15,
    }
  },
  mounted() {
    this.pageLoading = true
    this.page = 0
    this.rewardList = []
    this.loadMore().finally(() => {this.pageLoading = false})
  },
  methods: {
    loadMore() {
      this.loadMoreStatus = 'loading'
      return api.getRewardList({
        page: this.page,
        pageSize: this.pageSize,
        code: this.code || '',
        activityId: this.activityId || 0,
        activityType: 'CC',
      }).then(data => {
        if (data) {
          this.page++
          this.rewardList.push(...data.rewardList)
          this.rewardedAmount = data?.rewardedAmountSplit?.display || 0
          this.pendingAmount = data?.pendingAmountSplit?.display || 0
          this.loadMoreStatus = 
            data?.pageInfo.total < this.page * this.pageSize
            ? 'nomore'
            : 'suc'
          // this.loadMoreStatus = 'suc'
        } else {
          this.loadMoreStatus = 'fail'
        }
      }).catch((err) => {
        // err
        this.loadMoreStatus = 'fail'
      })
    },
    getRewardItemMoney(item) {
      // rewardStatus  0：待奖励；1：已经奖励；2：所有状态 -1: ???
      let rewardStatus = item.rewardStatus
      let money = item.amountSplit ? item.amountSplit.display : ''
      let str = (+rewardStatus === 2
        ? ''
        : money
      ) + (this?.rewardStatusMap[rewardStatus]?.desc || '')
      return str
    },
    iconClick() {
      this.$emit('icon-click')
    },
  }
}
</script>

<style lang="scss" scoped src="./index.scss"></style>